var e4 = e4 || {},
    theca = theca || {};
(function () {
    'use strict';
    theca.bootstrapInitialize = {
        init: function () {

            jQuery('.js-theca-popper-info-wdh').popover({
                placement : 'left',
                trigger : 'hover',
                html : true,
                content : '<img src="/admin/public/getimage.ashx?Image=/Files/Images/linedrawings/sofa-information-wdh.png&Width=0&Height=100&Format=png&Quality=75&Crop=0">'
            });

            jQuery( '.js-e-productlist' ).on( 'builded.e4.productlist', function () {
                jQuery( '[data-toggle="popover"]' ).popover();
            } );

            jQuery('.js-e-jsonpublisher').on('loaded.e4.jsonpublisher', function () {
                jQuery( '[data-toggle="popover"]' ).popover();
            });
        }
    };
    
    theca.siteWidePopup = {
        init: function() {
            var jSiteWidePopup = jQuery('.js-theca-sitewide-popup');
            var jSiteWidePopupCloseButton = jQuery('.js-theca-close-sitewide-popup');
            
            if(jSiteWidePopup.length > 0) {
                if (sessionStorage.getItem('e4.siteWidePopup.hasBeenAcknowledged') !== 'true') {
                    jSiteWidePopup.removeClass("d-none");

                    jSiteWidePopupCloseButton.on('click', function(event) {
                        jSiteWidePopup.addClass("d-none");
                        sessionStorage.setItem('e4.siteWidePopup.hasBeenAcknowledged', 'true');
                    })
                }
            }
        }
    };
    theca.productImageZoom = {
        init: function () {
            jQuery( '.e-product-image-modal' ).on( 'loaded.e4.jsonpublisher', '.js-e-jsonpublisher', function ( event ) {
                jQuery('.js-carousel-item-image-zoom').each(function (index, imageElm) {
                    jQuery(imageElm).zoom({
                        url: imageElm.dataset.src,
                        magnify: 1.5,
                        on: 'click',
                        onZoomIn: function () {
                            jQuery(this).addClass('zoom-in');
                        },
                        onZoomOut: function () {
                            jQuery(this).removeClass('zoom-in');
                        }
                    });
                });
            });
        }
    };
    theca.myOrders = {
        init: function(){
            if(jQuery('.js-theca-myorders-container').length > 0){
                e4.require.js( e4.settings.require.handlebars, function () {
                    e4.handlebars.registerTemplates( '#js-e-handlebars-tmpl-theca-myorders #js-e-handlebars-tmpl-theca-orderdetail' );
                    var defaultDocumentType = jQuery('.js-theca-myorders').find('select[name="documentType"]').val(); //'.js-theca-myorders-container'
                    console.log('defaultDocumentType', defaultDocumentType);
                    var objProductData = {'documentType': defaultDocumentType};
                    theca.myOrders.build( objProductData );
                    theca.myOrders.bindEvents();
                });
            }
        },
        bindEvents: function(){
            jQuery('.js-theca-orders-form').on('change', function( event ){
                var jElement = jQuery( event.target );

                console.log('change', jElement);

                jElement.closest('form').find('.form-group').each(function(index, element){
                    var jFormGroupElement = jQuery(element);

                    console.log('each', jFormGroupElement, jFormGroupElement.find('.js-theca-reset-field'));

                    if(jFormGroupElement.find('input').val() !== ''){
                        jFormGroupElement.find('.js-theca-reset-field').removeClass('d-none');
                    } else {
                        jFormGroupElement.find('.js-theca-reset-field').addClass('d-none');
                    }
                });
                theca.myOrders.build(jElement.closest('form').serialize());
            });
            jQuery('.js-theca-myorders-container').on('click', '.js-theca-orderdetail', function( event ){
                event.preventDefault();
                theca.myOrders.detail.build(jQuery(event.target).closest('a').data());
            });
            jQuery('.js-theca-myorders').on('click', '.js-theca-reset-field', function(event){
                 event.preventDefault();
                 var jElement = jQuery(event.target);
                 jElement.closest('.form-group').find('input').val('').trigger('change');
            });
            theca.myOrders.date();
        },
        build: function(objOrdersData){
            theca.myOrders.ajax( {
                method: 'GET',
                data: objOrdersData
            }, function ( data ) {
                jQuery('.js-theca-myorders').find('.js-orders-count').text(data.navDocument.DocCountInList);
                jQuery('.js-theca-myorders-container').html( e4.handlebars.tmpl.thecaMyorders( data ) );
                jQuery( '.js-theca-myorders' ).find('.js-e-loading-overlay').removeClass( 'is-loading' );
            } );
        },
        date: function () {
            var lang = jQuery( 'html' ).attr( 'lang' );
            var jStartDatePicker = jQuery( '.js-theca-order-start-date-picker-input' );
            if ( jStartDatePicker.length > 0 ) {
                jStartDatePicker.datepicker( {
                    language: lang,
                    format: jStartDatePicker.data( 'date-format' ),
                    autoclose: true,
                    orientation: 'bottom'
                } );
            }
            var jEndDatePicker = jQuery( '.js-theca-order-end-date-picker-input' );
            if ( jEndDatePicker.length > 0 ) {
                jEndDatePicker.datepicker( {
                    language: lang,
                    format: jEndDatePicker.data( 'date-format' ),
                    autoclose: true,
                    orientation: 'bottom'
                } );
            }
        },
        ajax: function ( objAjaxSettings, fnCallback ) {
            var jqXHR = jQuery.ajax( jQuery.extend( {
                url: e4.settings.ecom.myorders.url,
                method: 'POST',
                dataType: 'json',
                cache: false,
                beforeSend: function () {
                    jQuery( '.js-theca-myorders' ).find('.js-e-loading-overlay').addClass( 'is-loading' );
                }
            }, objAjaxSettings ) );
            jqXHR.done( function ( data ) {
                if ( typeof fnCallback === 'function' ) {
                    fnCallback( data );
                }
            } );
        },
        detail: {
            build: function(objData){
                console.log('DETAIL', objData, e4.settings.ecom.myorders.detail.url);
                theca.myOrders.detail.ajax( {
                    method: 'GET',
                    data: objData
                }, function ( data ) {
                    jQuery('.js-theca-orderdetail-container').html(e4.handlebars.tmpl.thecaOrderdetail(data));
                    jQuery( '.js-theca-order-detail' ).find('.js-e-loading-overlay').removeClass( 'is-loading' );
                } );
            },
            ajax: function ( objAjaxSettings, fnCallback ) {
                var jqXHR = jQuery.ajax( jQuery.extend( {
                    url: e4.settings.ecom.myorders.detail.url,
                    method: 'POST',
                    dataType: 'json',
                    cache: false,
                    beforeSend: function () {
                        jQuery('.js-theca-order-detail').modal('show');
                        jQuery('.js-theca-order-detail').find('.js-e-loading-overlay').addClass( 'is-loading' );
                    }
                }, objAjaxSettings ) );
                jqXHR.done( function ( data ) {
                    if ( typeof fnCallback === 'function' ) {
                        fnCallback( data );
                    }
                } );
            }
        }
    };

    theca.productlistProductImageSecondary = {
        init: function () {
            jQuery( '.js-e-productlist' ).on( 'builded.e4.productlist', function ( ) {
                var jProductlistExampleContainer = jQuery('.js-productlist-example-container');

                jProductlistExampleContainer.mouseleave(function (event) {
                    jQuery(event.target).closest('.js-e-productlist-item').find('.e-productlist-item-image.primary').fadeIn(150);
                });
                jProductlistExampleContainer.mouseenter(function (event) {
                    jQuery(event.target).closest('.js-e-productlist-item').find('.e-productlist-item-image.primary').fadeOut(150);
                });
                jQuery('.productlist-example-image.example-0').mouseenter(function (event) {
                    jQuery(event.target).closest('.js-e-productlist-item').find('.e-productlist-item-image.example-0').fadeIn(150);
                    jQuery('.e-productlist-item-image.example-1').fadeOut(150);
                });
                jQuery('.productlist-example-image.example-1').mouseenter(function (event) {
                    jQuery(event.target).closest('.js-e-productlist-item').find('.e-productlist-item-image.example-1').fadeIn(150);
                    jQuery('.e-productlist-item-image.example-0').fadeOut(150);
                });
            });
        }
    };
    theca.materialFilter = {
        init: function(){
            if(jQuery('#js-theca-material-filters').length > 0){
                theca.materialFilter.bindEvents();
            }
        },
        bindEvents: function () {
            jQuery('#js-theca-material-filters').on('change' , 'input[type="checkbox"]', function(event){
                var jParent = jQuery(event.delegateTarget);
                var variantOptions = theca.materialFilter.variantOptions;
                variantOptions.closest('.js-theca-color-group-item').addClass('d-none');
                jQuery('.js-theca-color-groups').addClass('d-none');

                jParent.find('.dropdown-menu').each(function(intIndex, domElement){
                    var domCollectionElement = domElement;
                    if(jQuery(domCollectionElement).find('input:checked').length > 0){
                        variantOptions = variantOptions.filter(function(intIndex, element){
                            var matchHits = jQuery(domCollectionElement).find('input:checked').filter(function(intIndex, inputElement){
                                return jQuery(element).attr('title').toString().toLowerCase().indexOf(jQuery(inputElement).val().toString().toLowerCase()) > -1;
                            });
                            return  matchHits.length > 0;
                        });
                    }
                });
                variantOptions.closest('.js-theca-color-group-item').removeClass('d-none');

                jQuery('.js-theca-color-groups').filter(function(intIndex, element){
                    return jQuery(element).find('.js-theca-color-group-item').length !== jQuery(element).find('.js-theca-color-group-item.d-none').length;
                }).removeClass('d-none');

                var noResults = jQuery('.js-theca-color-groups.d-none').length === jQuery('.js-theca-color-groups').length;
                if(noResults){
                    jQuery('.js-no-results').removeClass('d-none');
                } else {
                    jQuery('.js-no-results').addClass('d-none');
                }
            });

        },
        variantOptions: jQuery('#materialModal').find('.variant-color')
    };
    theca.string = {
        format: function () {
            var s = arguments[0];
            for (var i = 0; i < arguments.length - 1; i++) {
                var reg = new RegExp("\\{" + i + "\\}", "gm");
                s = s.replace(reg, arguments[i + 1]);
            }
            return s;
        }
    };
    theca.ecom = {
        init: function () {
            theca.ecom.checkout.dealerSearch.init();
        },
        checkout: {
            dealerSearch: {
                init: function () {
                    if (jQuery('.js-e-cart-b2c').length === 1) {
                        jQuery('.js-e-cart').on('loaded.e4.cart', function (event, data) {
                            e4.require.js(e4.settings.require.handlebars, function () {
                                e4.handlebars.registerHelpers('compare');
                                e4.handlebars.registerTemplates('#js-e-handlebars-tmpl-cart-b2c-dealer');
                                theca.ecom.checkout.dealerSearch.bindEvents();
                                theca.ecom.checkout.dealerSearch.build(data);
                            });
                        });
                        if (e4.util.hash.get('dealerselect') === 'true') {
                            jQuery(document).on('loaded.e4.dealersearch', function () {
                                jQuery('.js-theca-cart-dealersearch-modal').modal('show');
                            });
                        }
                    }
                },
                getData: function (strTypes) {
                    var jDealersearch = jQuery('.js-e-dealersearch');
                    return jQuery.ajax({
                        url: e4.settings.dealersearch.url,
                        data: {
                            groupId: jDealersearch.data( 'groupId' ),
                            countryCode: jDealersearch.data( 'countryCode' ),
                            type: strTypes
                        },
                        dataType: 'json',
                        cache: false
                    }).done(function (jsonData) {
                        e4.dealersearch.data = jsonData;
                    });
                },
                setType: function () {
                    var typeArr = [];
                    jQuery( '.js-e-orderline' ).each( function ( index, element ) {
                        if ( jQuery( element ).data( 'isVariantMaster' ) === true ) {
                            typeArr.push( 'ThecaVariant' );
                        }
                    } );
                    jQuery.when( theca.ecom.checkout.dealerSearch.getData( typeArr.join( ',' ) ) ).then( function () {
                        e4.dealersearch.map.setBoundsFromCountry();
                        // e4.dealersearch.form.clearInput();
                        e4.dealersearch.markers.removeFromClusterer();
                        e4.dealersearch.markers.init();

                    } );
                },
                bindEvents: function () {
                    jQuery('.js-theca-cart-dealersearch-modal').on('show.bs.modal', function () {
                        theca.ecom.checkout.dealerSearch.setType();
                    }).on('hide.bs.modal', function () {
                        e4.util.hash.remove('dealerselect');
                    }).on('click', '.js-theca-cart-dealersearch-select', function (event) {
                        event.preventDefault();
                        theca.ecom.checkout.dealerSearch.select(jQuery(this).data('id'));
                    });

                },
                select: function (dealerId) {
                    var dealer = e4.dealersearch.data.users.filter(function (obj) {
                        return parseInt(obj.id) === dealerId;
                    })[0];
                    if (dealer) {
                        var dealerObj = {
                            EcomOrderCustomerDealer: dealer.id,
                            EcomOrderDeliveryName: dealer.name,
                            EcomOrderDeliveryAddress: dealer.address,
                            EcomOrderDeliveryAddress2: dealer.address2,
                            EcomOrderDeliveryZip: dealer.zip,
                            EcomOrderDeliveryCity: dealer.city,
                            EcomOrderDeliveryCountry: dealer.country,
                            EcomOrderDeliveryCountryCode: dealer.countryCode,
                            EcomOrderDeliveryPhone: dealer.phone,
                            EcomOrderDeliveryEmail: dealer.mail,
                            Company: dealer.company
                        };
                        theca.ecom.checkout.dealerSearch.set(dealerObj);
                    }
                },
                set: function (dealerObj) {
                    e4.cart.ajax({
                        data: dealerObj
                    }, function (data) {
                        jQuery('.js-theca-cart-dealersearch-modal').modal('hide');
                        theca.ecom.checkout.dealerSearch.build(data);
                    });
                },
                build: function (data) {
                    jQuery('.js-e-cart-b2c-dealer-container').html(e4.handlebars.tmpl.cartB2cDealer(data.cart.dealer));
                }
            }
        }
    };
    theca.filePublisher = {
        init: function () {
            if ( jQuery( '.js-theca-filepublisher-form' ).length > 0 ) {
                theca.filePublisher.bindEvents();
            }
        },
        bindEvents: function () {
            jQuery( '.js-theca-filepublisher-form' ).on( 'change', function ( event ) {
                jQuery( '.js-theca-filepublisher-loading-overlay' ).addClass( 'is-loading' );
                jQuery( '.js-theca-filepublisher-container' ).css( {
                    'overflow': 'hidden',
                    'height': '10em'
                } );
                jQuery( '.js-theca-filepublisher-form' ).submit();
            } );
        }
    };
}());
